<template>
<div id="app" class="gpBGcolor">
	<nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
        <div class="container">
            <a class="navbar-brand" href="https://glowpuff.com/legacy/#/"><span class="GP rounded-circle align-middle mr-2"></span>Legacy Apps</a>
            <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
			<div class="collapse navbar-collapse" id="navbarResponsive">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="https://glowpuff.com">Home</a>
                    </li>
                </ul>
			</div>
        </div>
	</nav>
	<keep-alive>
	<router-view></router-view>
	</keep-alive>
</div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
@import "assets/glowpuff.css";
</style>



// WEBPACK FOOTER //
// src/App.vue